import React, { useState, useEffect } from 'react';
import { FormattedNumber } from 'react-intl';
import { get as _get } from 'lodash-es';
// export default function App() {
const defaultCurrency = _get(
  window,
  'compatioConfig.compatibleProducts.currency'
);

const Price = ({ filterType, updateValueToFilters, appliedFilters }) => {
  // console.log(JSON.stringify(filterType.values),'filterType')
  // Find the highest and lowest values
  const values = filterType.values.map(item => item.value);
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values) + 1;
  const [price, setPrice] = useState(
    appliedFilters.filter(e => e.name == 'priceFilter').length != 0
      ? +appliedFilters.filter(e => e.name == 'priceFilter')[0].value
      : +maxValue
  );
  // setPrice(appliedFilters.filter(e => e.name == 'priceFilter').length != 0 ? +appliedFilters.filter(e => e.name == 'priceFilter')[0].value  : +maxValue)
  // console.log(minValue,maxValue,price,appliedFilters.filter(e => e.name == 'priceFilter').length,'88888')
  // Triggered when the value gets updated while scrolling the slider:
  const handleInput = e => {
    setPrice(e.target.value);
  };
  const handleOnChangeInput = e => {
    updateValueToFilters(
      'Price Filter',
      'priceFilter',
      undefined,
      e.target.value,
      undefined
    );
  };
  useEffect(() => {
    setPrice(
      appliedFilters.filter(e => e.name == 'priceFilter').length != 0
        ? +appliedFilters.filter(e => e.name == 'priceFilter')[0].value
        : +maxValue
    );
    console.log(price);
  }, [maxValue]);

  return (
    <>
      <input
        type="range"
        min={minValue}
        max={maxValue}
        defaultValue={price}
        onInput={handleInput}
        onClickCapture={handleOnChangeInput}
        onTouchEndCapture={handleOnChangeInput}
      />
      <span class="lowprice">Low</span>
      <span class="highprice">High</span>
      <p>
        <span></span>
        <FormattedNumber
          value={price}
          style="currency"
          currency={defaultCurrency}
          minimumFractionDigits={2}
          maximumFractionDigits={2}
        />
      </p>
    </>
  );
};
export default Price;
